import { MAIN_DATA_KEY } from 'modules/Monitoring/consts/chart'
import { ChartData, ChartDataValues, TableDataItem } from 'modules/Monitoring/types'

export const prepareTableDataFromChartData = (
  data: ChartData,
  keyGetter?: (key: string) => string,
): TableDataItem[] => {
  const dataConfig = data.reduce<Record<string, ChartDataValues>>((acc, curr) => {
    for (const [key, value] of Object.entries(curr[MAIN_DATA_KEY])) {
      if (!acc[key]) {
        acc[key] = {}
      }

      acc[key][curr.date.toString()] = value
    }

    return acc
  }, {})

  return Object.entries(dataConfig).map(([key, value]) => ({
    ...value,
    name: keyGetter ? keyGetter(key) : key,
    value: key,
  }))
}
